// @ref https://stackoverflow.com/a/57062675/3903082
import { InjectionToken } from '@angular/core';

export interface AppConfig {
  displayVersionNumber: string;
  apiBaseUri: string;
  azureFunctionsApiBaseUri: string;
  aadRedirectUri: string;
  [key: string]: unknown;
}

export const APP_CONFIG = new InjectionToken<AppConfig>('Application config');
